import { render, staticRenderFns } from "./lazy-background.vue?vue&type=template&id=fd557834&scoped=true&"
import script from "./lazy-background.vue?vue&type=script&lang=js&"
export * from "./lazy-background.vue?vue&type=script&lang=js&"
import style0 from "./lazy-background.vue?vue&type=style&index=0&id=fd557834&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd557834",
  null
  
)

export default component.exports